import { render } from "./ElementOptionsSettingsPanel.vue?vue&type=template&id=2c48049a&ts=true"
import script from "./ElementOptionsSettingsPanel.vue?vue&type=script&lang=ts"
export * from "./ElementOptionsSettingsPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QOptionGroup});
